import { Events } from "~/web-frontend-core/utils/enums/kafka";
import { KafkaLogger } from "~/web-frontend-core/utils/KafkaLogger/KafkaLogger";
export { Events };
export const sendLogKafka = (eventName, detail) => {
    KafkaLogger.getInstance().sendLog(eventName, detail);
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/helpers/kafka.js